<template>
  <v-tabs
    class="navbar-tabs"
    :class="isInstanceDetails ? 'tabs-none-active' : ''"
    prev-icon="$chevronleft"
    next-icon="$chevronright"
    center-active
    v-model="tab"
  >
    <v-tab
      v-for="tab in tabs"
      :key="tab.key"
      v-ripple="false"
      :to="tab.route"
      class="p-1 font-weight-600 top-bar__item"
      :exact="tab.exact"
    >
      {{ tab.label }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    isAppSingleServer() {
      return !!this.$store.state.home.app.single_server?.active;
    },
    tabs() {
      let tabs = [
        {
          key: "my-instances",
          label: this.$t("heading.navbar.tab.myInstances"),
          route: "/instances/",
          exact: true,
        },
      ];
      if (this.hasHostingAccess) {
        tabs.push({
          key: "my-hosting",
          label: this.isAppSingleServer
            ? this.$t("heading.navbar.tab.myServer")
            : this.$t("heading.navbar.tab.myHosting"),
          route: "/hosting/",
        });
      }
      if (this.hasResellerAreaAccess) {
        tabs.push({
          key: "reseller-area",
          label: this.$t("heading.navbar.tab.resellerArea"),
          route: "/reseller-area/",
        });
      }
      return tabs;
    },
    hasHostingAccess() {
      return this.$store.state?.home?.user?.has_hosting_access === true;
    },
    hasResellerAreaAccess() {
      return (
        this.$store.state.home &&
        this.$store.state.home.user &&
        "reseller_settings" in this.$store.state.home.user &&
        this.$store.state.home.user.reseller_settings !== null
      );
    },
    isInstanceDetails: function () {
      return (
        this.$route.path.includes("instances") &&
        this.$route.name !== "Instances"
      );
    },
  },
};
</script>

<style src="./NavbarTopNavigation.scss" lang="scss" scoped />
